// ==========================================================
// MAMOURSE BUNDLE BUILDER - JavaScript
// FULL FIXED VERSION
// Adds bundle to Shopify real cart + Mamourse header cart drawer
// Paste in Assets → bundle-builder.js
// ==========================================================

(function() {
  let selectedBundleSize = 3;
  let selectedItems = [];
  let discountCodes = { 3: 'BUNDLE10', 6: 'BUNDLE15', 9: 'BUNDLE20' };

  const bundleOptions = document.querySelectorAll('.bundle-option');
  const selectedContainer = document.getElementById('selectedProductsContainer');
  const progressText = document.getElementById('progressText');
  const bundleSubtotal = document.getElementById('bundleSubtotal');
  const addBundleBtn = document.getElementById('addBundleBtn');

  function escapeHtml(str) {
    if (!str) return '';
    return str.replace(/[&<>]/g, function(m) {
      if (m === '&') return '&amp;';
      if (m === '<') return '&lt;';
      if (m === '>') return '&gt;';
      return m;
    });
  }

  function updateUI() {
    if (!selectedContainer) return;

    selectedContainer.innerHTML = '';

    for (let i = 0; i < selectedBundleSize; i++) {
      const item = selectedItems[i];
      const slotDiv = document.createElement('div');
      slotDiv.className = 'selected-slot' + (item ? '' : ' empty');

      if (item) {
        slotDiv.innerHTML = `
          <img src="${item.image}" class="selected-slot-image" onerror="this.src='https://via.placeholder.com/55'">
          <div class="selected-slot-info">
            <div class="selected-slot-title">${escapeHtml(item.title)}</div>
            <div class="selected-slot-variant">${escapeHtml(item.variantTitle)}</div>
          </div>
          <button class="remove-slot" data-index="${i}">✕</button>
        `;
      } else {
        slotDiv.innerHTML = `
          <div class="empty-placeholder">
            <div class="empty-placeholder-icon">🧸</div>
            <div class="selected-slot-info">
              <div class="selected-slot-title">Empty slot</div>
              <div class="selected-slot-variant">Add a product</div>
            </div>
          </div>
        `;
      }

      selectedContainer.appendChild(slotDiv);
    }

    const remaining = selectedBundleSize - selectedItems.length;

    if (progressText) {
      if (remaining === 0) {
        progressText.innerHTML = '🎉 Ready to add to cart! 🎉';
        progressText.style.background = '#A39385';
        progressText.style.color = 'white';
      } else {
        progressText.innerHTML = `Pick ${remaining} more product${remaining !== 1 ? 's' : ''}`;
        progressText.style.background = '#FFFEC8';
        progressText.style.color = '#2C3E4E';
      }
    }

    if (bundleSubtotal) {
      const total = selectedItems.reduce((sum, item) => sum + (item.price || 0), 0);
      bundleSubtotal.innerHTML = '$' + total.toFixed(2);
    }

    if (addBundleBtn) {
      addBundleBtn.disabled = selectedItems.length !== selectedBundleSize;

      if (selectedItems.length === selectedBundleSize) {
        addBundleBtn.textContent = 'Add Bundle to Cart';
      }
    }
  }

  async function addToBasket(productData) {
    if (selectedItems.length >= selectedBundleSize) {
      alert(`You can only select ${selectedBundleSize} items for this bundle.`);
      return false;
    }

    if (selectedItems.some(item => item.variantId === productData.variantId)) {
      alert('This product is already in your basket.');
      return false;
    }

    selectedItems.push(productData);
    updateUI();
    return true;
  }

  function removeFromBasket(index) {
    selectedItems.splice(index, 1);
    updateUI();
  }

  async function addBundleToCart() {
    if (selectedItems.length !== selectedBundleSize) {
      alert(`Please select ${selectedBundleSize} items first.`);
      return;
    }

    if (addBundleBtn) {
      addBundleBtn.disabled = true;
      addBundleBtn.textContent = 'Adding to Cart...';
    }

    try {
      const shopifyItems = selectedItems.map(item => ({
        id: parseInt(item.variantId, 10),
        quantity: 1
      }));

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: shopifyItems
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.description || 'Failed to add bundle to Shopify cart');
      }

      if (typeof window.addToCart === 'function') {
        selectedItems.forEach(item => {
          window.addToCart({
            variant_id: parseInt(item.variantId, 10),
            title: item.title,
            price: parseFloat(item.price) || 0,
            quantity: 1,
            image: item.image || ''
          });
        });
      }

      selectedItems = [];
      updateUI();

      if (addBundleBtn) {
        addBundleBtn.disabled = true;
        addBundleBtn.textContent = 'Added to Cart ✓';
      }

      setTimeout(() => {
        if (addBundleBtn) {
          addBundleBtn.textContent = 'Add Bundle to Cart';
          updateUI();
        }
      }, 1200);

    } catch (error) {
      console.error('Bundle add error:', error);
      alert('There was an error adding the bundle to cart. Please try again.');

      if (addBundleBtn) {
        addBundleBtn.disabled = false;
        addBundleBtn.textContent = 'Add Bundle to Cart';
      }
    }
  }

  if (bundleOptions) {
    bundleOptions.forEach(option => {
      option.addEventListener('click', () => {
        const size = parseInt(option.dataset.size);
        selectedBundleSize = size;

        if (selectedItems.length > selectedBundleSize) {
          selectedItems = selectedItems.slice(0, selectedBundleSize);
        }

        bundleOptions.forEach(opt => opt.classList.remove('active'));
        option.classList.add('active');

        updateUI();
      });
    });
  }

  if (selectedContainer) {
    selectedContainer.addEventListener('click', (e) => {
      const removeBtn = e.target.closest('.remove-slot');

      if (removeBtn) {
        const index = parseInt(removeBtn.dataset.index);
        removeFromBasket(index);
      }
    });
  }

  function attachAddToCartEvents() {
    document.querySelectorAll('.add-btn').forEach(btn => {
      if (btn._listener) {
        btn.removeEventListener('click', btn._listener);
      }

      const listener = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (btn.classList.contains('sold-out')) {
          alert('This product is sold out.');
          return;
        }

        const productCard = btn.closest('.product-card');
        const productTitle = productCard.querySelector('.product-title')?.innerText || 'Product';
        const productImage = productCard.querySelector('.product-image img')?.src || '';

        let variantId = btn.dataset.variantId;
        let variantTitle = 'Default';
        let price = parseFloat(btn.dataset.price) || 0;

        const variantSelect = productCard.querySelector('.variant-select');

        if (variantSelect && variantSelect.tagName === 'SELECT') {
          const selectedOption = variantSelect.options[variantSelect.selectedIndex];

          variantId = selectedOption.value;
          variantTitle = selectedOption.text.split(' - ')[0];

          const priceMatch = selectedOption.text.match(/\$([0-9.]+)/);

          if (priceMatch) {
            price = parseFloat(priceMatch[1]);
          }
        }

        await addToBasket({
          variantId: variantId,
          title: productTitle,
          variantTitle: variantTitle,
          price: price,
          image: productImage
        });
      };

      btn.addEventListener('click', listener);
      btn._listener = listener;
    });
  }

  attachAddToCartEvents();

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        attachAddToCartEvents();
      }
    });
  });

  const productsGrid = document.getElementById('bundleProductsGrid');

  if (productsGrid) {
    observer.observe(productsGrid, {
      childList: true,
      subtree: true
    });
  }

  if (addBundleBtn) {
    addBundleBtn.addEventListener('click', addBundleToCart);
  }

  updateUI();
})();